<template>
  <div>

    <vs-row v-if="prevPost.postId !== 0 || nextPost.postId !== 0 ">
      <vs-col class="header-tool mb-8" vs-type="flex" vs-justify="flex-end">
        <span v-if="prevPost.postId !== 0" @click="handleClickPrevPost">&lt; 이전글</span>
        <span v-if="prevPost.postId !== 0 && nextPost.postId !== 0 ">|</span>
        <span v-if="nextPost.postId !== 0" @click="handleClickNextPost">다음글 &gt;</span>
      </vs-col>
    </vs-row>

    <vx-card class="mb-8">

      <!-- 글 작성 정보 -->
      <vs-row class="read-layout-flex">
        <div class="flex" style="display: flex !important; flex-wrap: wrap;">
          <vs-col class="read-layout-item">
            <h5 class="title">작성자</h5>
            <span class="content">{{ (post.author ? post.author.username : '') }}</span>
          </vs-col>

          <vs-col class="read-layout-item">
            <h5 class="title">이메일</h5>
            <span class="content">{{ (post.author ? post.author.email : '') }}</span>
          </vs-col>

          <vs-col class="read-layout-item">
            <h5 class="title">구분</h5>
            <span class="content">회원가입</span>
          </vs-col>

          <vs-col class="read-layout-item">
            <h5 class="title">작성일</h5>
            <span class="content">{{ post.created_at }}</span>
          </vs-col>
        </div>

        <div class="ml-auto flex" style="align-items: center">본문이동</div>

      </vs-row>

      <!--    구분선 -->
      <vs-divider></vs-divider>

      <!--    제목-->
      <vs-row class="read-layout-2">
        <vs-col class="read-layout-title">제목</vs-col>
        <vs-col>
          <span class="float-left">{{ post.post_title }}</span>
        </vs-col>
      </vs-row>

      <!--    내용-->
      <vs-row class="read-layout-2">
        <vs-col class="read-layout-title top">내용</vs-col>
        <vs-col>
          <div class="content-read" v-html="post.post_content"></div>
        </vs-col>
      </vs-row>

      <!--    구분선 -->
      <vs-divider v-if="post.post_attachment && post.post_attachment.length > 0"></vs-divider>


      <!--    첨부파일-->
      <vs-row v-if="post.post_attachment && post.post_attachment.length > 0"
              class="read-layout-2">
        <vs-col class="read-layout-title top">첨부파일</vs-col>
        <vs-col>
          <vs-upload class="read-vs-upload" ref="vs_upload" :show-upload-button="false" disabled></vs-upload>
        </vs-col>
      </vs-row>

      <vs-row v-if="prevPost.postId !== 0" class="read-layout-footer">
        <vs-col class="read-layout-title">이전글</vs-col>
        <vs-col class="h-full pl-8">
          <span @click="handleClickPrevPost">{{ prevPost.post_title }}</span>
        </vs-col>
      </vs-row>

      <vs-row v-if="nextPost.postId !== 0" class="read-layout-footer">
        <vs-col class="read-layout-title">다음글</vs-col>
        <vs-col class="h-full pl-8">
          <span @click="handleClickNextPost">{{ nextPost.post_title }}</span>
        </vs-col>
      </vs-row>

    </vx-card>

    <!-- 댓글 달기 -->
    <vx-card class="add-comment mb-wide">
      <vs-row>
        <vs-col class="">
          <vs-textarea class="mb-0" rows="3" v-model="comment"/>
        </vs-col>
        <vs-col class="col-fix-buttons" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-button color="secondary" @click="handleClickAddComment">등록하기</vs-button>
        </vs-col>
      </vs-row>
    </vx-card>

    <vs-row class="mb-big-wide" vs-type="flex">
      <vs-col class="vs-button-list-left">
        <vs-row >
          <!-- 작성자인 경우 -->
          <vs-col v-if="isAuthor">
            <vs-button class="mr-2" color="secondary" type="border" @click="handleDeletePost">삭제</vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col class="vs-button-list-right">
        <vs-row >
          <!-- 작성자인 경우 -->
          <vs-col v-if="isAuthor">
            <vs-button class="mr-2" type="border" @click="handleClickPostList">목록</vs-button>
            <vs-button class="mr-2" type="border" @click="handleClickRegister">글쓰기</vs-button>
            <vs-button class="mr-2" type="border" @click="handleClickReply">답글</vs-button>
            <vs-button class="" color="secondary" @click="handleClickModify">수정</vs-button>
          </vs-col>

          <!-- 작성자가 아닌 경우 -->
          <vs-col v-else>
            <vs-button class="mr-2" type="border" @click="handleClickPostList">목록</vs-button>
            <vs-button class="mr-2" type="border" @click="handleClickRegister">글쓰기</vs-button>
            <vs-button class="" type="border" @click="handleClickReply">답글</vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <!--  댓글  -->
    <vx-card class="p-6 mb-wide">
      <div class="w-full flex" slot="no-body">
        <h5 class="mr-auto flex items-center">
          <b>댓글목록</b>
          <b class="ml-2 secondary">3</b>
        </h5>
      </div>
    </vx-card>

    <vx-card >

      <div class="comment-item comment-item-0">
        <vs-row class="comment-view mb-4">
          <vs-col>
            <vs-row class="comment-view-body">
              <vs-col class="col-img" >
                <vs-images hover="zoom" >
                  <vs-image class="w-full h-full" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQvEN7nrZtF_Alf0hUaaPnNSS3tGlffJFbjBA&usqp=CAU"></vs-image>
                </vs-images>
              </vs-col>
              <vs-col class="pl-4" vs-type="grid" vs-align="center">
                <vs-col >
                  <span>작성자</span>
                  <span class="ml-8">2020-02-02</span>
                  <span class="ml-8">20:20</span>
                </vs-col>
                <vs-col>마엇의 관리자 페이지가 오픈했습니다. 편리하게 이용하는 방법을 소개합니다!</vs-col>
              </vs-col>

            </vs-row>
          </vs-col>
          <vs-col class="col-fix-buttons " vs-type="flex" vs-align="center" vs-justify="flex-end">
            <vs-button class="mr-2" color="#eaeaea" text-color="black" @click="(event)=>{ openWrite(event, '0') }">답글</vs-button>
            <vs-button class="mr-2" type="border" text-color="black" @click="(event)=>{ openWrite(event, '0') }">수정</vs-button>
            <vs-button class="" color="#eaeaea" text-color="black">삭제</vs-button>
          </vs-col>
        </vs-row>

        <vs-row class="comment-write" vs-type="flex">
          <vs-textarea class="w-full" rows="2" />
          <vs-button class="ml-auto mr-2" color="secondary" >등록</vs-button>
          <vs-button type="border" @click="(event)=>{ closeWrite(event, '0') }">취소</vs-button>
        </vs-row>

      </div>

      <div class="comment-item comment-item-1 sub-1">
        <vs-row class="comment-view mb-4">
          <vs-col>
            <vs-row class="comment-view-body">
              <vs-col class="col-img" >
                <vs-images hover="zoom" >
                  <vs-image class="w-full h-full" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQvEN7nrZtF_Alf0hUaaPnNSS3tGlffJFbjBA&usqp=CAU"></vs-image>
                </vs-images>
              </vs-col>
              <vs-col class="pl-4" vs-type="grid" vs-align="center">
                <vs-col >
                  <span>작성자</span>
                  <span class="ml-8">2020-02-02</span>
                  <span class="ml-8">20:20</span>
                </vs-col>
                <vs-col>마엇의 관리자 페이지가 오픈했습니다. 편리하게 이용하는 방법을 소개합니다!</vs-col>
              </vs-col>

            </vs-row>
          </vs-col>
          <vs-col class="col-fix-buttons " vs-type="flex" vs-align="center" vs-justify="flex-end">
            <vs-button class="mr-2" color="#eaeaea" text-color="black" @click="(event)=>{ openWrite(event, '1') }">답글</vs-button>
            <vs-button class="mr-2" type="border" text-color="black" @click="(event)=>{ openWrite(event, '1') }">수정</vs-button>
            <vs-button class="" color="#eaeaea" text-color="black">삭제</vs-button>
          </vs-col>
        </vs-row>

        <vs-row class="comment-write" vs-type="flex">
          <vs-textarea class="w-full" rows="2" />
          <vs-button class="ml-auto mr-2" color="secondary" >등록</vs-button>
          <vs-button type="border" @click="(event)=>{ closeWrite(event, '1') }">취소</vs-button>
        </vs-row>

      </div>

      <div class="comment-item comment-item-2 sub-2">
        <vs-row class="comment-view mb-4">
          <vs-col>
            <vs-row class="comment-view-body">
              <vs-col class="col-img" >
                <vs-images hover="zoom" >
                  <vs-image class="w-full h-full" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQvEN7nrZtF_Alf0hUaaPnNSS3tGlffJFbjBA&usqp=CAU"></vs-image>
                </vs-images>
              </vs-col>
              <vs-col class="pl-4" vs-type="grid" vs-align="center">
                <vs-col >
                  <span>작성자</span>
                  <span class="ml-8">2020-02-02</span>
                  <span class="ml-8">20:20</span>
                </vs-col>
                <vs-col>마엇의 관리자 페이지가 오픈했습니다. 편리하게 이용하는 방법을 소개합니다!</vs-col>
              </vs-col>

            </vs-row>
          </vs-col>
          <vs-col class="col-fix-buttons " vs-type="flex" vs-align="center" vs-justify="flex-end">
            <vs-button class="mr-2" color="#eaeaea" text-color="black" @click="(event)=>{ openWrite(event, '2') }">답글</vs-button>
            <vs-button class="mr-2" type="border" text-color="black" @click="(event)=>{ openWrite(event, '2') }">수정</vs-button>
            <vs-button class="" color="#eaeaea" text-color="black">삭제</vs-button>
          </vs-col>
        </vs-row>

        <vs-row class="comment-write" vs-type="flex">
          <vs-textarea class="w-full" rows="2" />
          <vs-button class="ml-auto mr-2" color="secondary" >등록</vs-button>
          <vs-button type="border" @click="(event)=>{ closeWrite(event, '2') }">취소</vs-button>
        </vs-row>

      </div>

    </vx-card>

  </div>
</template>

<script>

export default {
  name: 'TemplateDetailNormal2',

  props: {
    isAuthor: { type: Boolean, default: false },

    post: Object,
    prevPost: Object, // prevPost = {title, postId}
    nextPost: Object // nextPost = {title, postId}
  },

  watch: {
    post () {
      const attachment = this.post.post_attachment
      for (let i = 0; i < attachment.length; i++) {
        this.setVsUploadImage(this, attachment[i].path)
      }
    }
  },

  data () {
    return {
      comment:''
    }
  },

  methods: {

    // vs-upload에 초기 이미지 넣기
    setVsUploadImage (_t, src) {
      let orientation = 'h'
      const image = new Image()
      image.src = src
      image.onload = function () {
        if (this.width > this.height) {
          orientation = 'w'
        }
        _t.$refs.vs_upload.srcs.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
        _t.$refs.vs_upload.filesx.push({
          src: this.src,
          orientation,
          type: 'image',
          percent: null,
          error: false,
          remove: false
        })
      }
    },

    handleClickPrevPost () {
      this.$emit('handleClickPrevPost', this.prevPost)
    },

    handleClickNextPost () {
      this.$emit('handleClickNextPost', this.nextPost)
    },

    handleDeletePost () {
      this.$emit('handleDeletePost', this.post)
    },

    handleClickPostList () {
      this.$emit('handleClickPostList')
    },

    handleClickModify () {
      this.$emit('handleClickModify', this.post)
    },

    handleClickRegister () {
      this.$emit('handleClickRegister')
    },

    handleClickReply () {
      this.$emit('handleClickReply', this.post)
    },

    handleClickAddComment () {
      this.$emit('handleClickAddComment', this.post, this.comment, 0)
    }
  }
}
</script>

<style scoped>
.content-head {
  width: 100px;
  font-weight: bold;
}

.content-read {
  min-height: 20em;
  line-height: 1.6;
}

.read-layout-flex {
  display: flex !important;
}
.read-layout-2 {
  display: grid !important;
  grid-template-columns: 60px 1fr;
  margin-bottom:1.5rem;
}
.read-layout-flex .read-layout-item {
  display: flex;
  min-width:2.8rem;
  width: auto !important;
  margin-right: 5rem;
  margin-top:0.5rem;
  margin-bottom: 0.5rem;
}
.read-layout-flex .read-layout-item h5 {
  display: block;
  font-size:1rem;
  min-width:2.8rem;

  color:#2c2c2c
}
.read-layout-flex .read-layout-item span {
  font-size:1rem;
  margin-left:2rem;
}
.read-layout-title {
  font-weight: bold;
  display: flex;
  align-items: center;
}
.read-layout-title.top{
  align-items: start;
}

.read-layout-footer{
  width: auto !important;
  height:50px;
  display:  grid !important;
  grid-template-columns: 120px 1fr;
  align-items: center;

  margin-left:-1.5rem;
  margin-right:-1.5rem;
  border-top:1px solid #f2f2f2 !important;
}
.read-layout-footer .read-layout-title{
  height:100%;
  justify-content: center;

  background-color: #EDEDED;
}
.read-layout-footer span {
  height:100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.read-layout-footer:last-child {
  margin-bottom:-1.5rem;
}

.add-comment .vs-row {
  display: grid !important;
  margin-right:-1.5rem;
  grid-template-columns: minmax(0%, 100%) 12rem;
}

.mb-wide { margin-bottom:1.5rem !important;}
.mb-big-wide { margin-bottom:4.5rem !important; }
.vs-button-list-left { width:auto !important; }
.vs-button-list-right { width:auto !important; margin-left:auto !important;}

b.secondary { color: rgb(102,112,203)}

.comment-item {
  border-bottom: 1px solid #EAEAEA;
  margin-bottom: 1.5rem;
}
.comment-item:last-child{
  border-bottom:none;
  margin-bottom: 0;
}
.comment-item.sub-1 {
  padding-left: 4.5rem;
}
.comment-item.sub-2 {
  padding-left: 9rem;
}
.comment-view {
  display: grid !important;
  grid-template-columns: minmax(0%,100%) 300px;
}
.comment-view-body {
  display: grid !important;
  grid-template-columns: 70px minmax(0%,100%);
  grid-template-rows:70px;
}
.comment-write{
  margin-top:1.5rem;
  margin-bottom:1.5rem;

  display: none !important;
}
.comment-write.open{
  display: flex !important;
}
</style>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}

.read-vs-upload .btn-x-file {
  visibility: hidden;
}

.add-comment .vx-card__collapsible-content .vx-card__body {
  padding-right:0px !important;
}

.col-img .vs-image--img{
  background-color: #C4C4C4 !important;
}
</style>
